import { render, staticRenderFns } from "./PhonePreviewFilters.vue?vue&type=template&id=318bec4e&scoped=true&"
import script from "./PhonePreviewFilters.vue?vue&type=script&lang=js&"
export * from "./PhonePreviewFilters.vue?vue&type=script&lang=js&"
import style0 from "./PhonePreviewFilters.vue?vue&type=style&index=0&id=318bec4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318bec4e",
  null
  
)

export default component.exports